<template>
  <div>
    <div v-if="messageType === 'error'">
      <v-alert type="error" dense text>
        {{ message }}
      </v-alert>
    </div>
    <div v-else-if="messageType === 'warning'">
      <v-alert dense text type="warning">
        {{ message }}
      </v-alert>
    </div>
    <div v-else-if="messageType === 'success'">
      <v-alert dense text type="success">
        {{ message }}
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    messageType: String
  }
}
</script>

<style lang="scss" scoped>
</style>